import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './shared/styles/index.scss';
import Main from '../src/Main';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Store } from './store';

ReactDOM.render(
  <Provider store={Store}>
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);

